import React, { useState, useEffect, useRef } from "react";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import {useNavigate, useParams } from "react-router-dom";
import Navbar from "@/Components/navbar";
import Diagram from "./Diagram/index";
import Palette from "./Diagram/Palette";
import Overview from "./Diagram/Overview";
import userInfo from "@/Components/user";
import * as go from "gojs";

import emptyJosn from "../../../Main/empty.json";
import flowData from "./dataJson/flowData.json";
import globalData from "./dataJson/globalData.json";
import basicTreeData from "./dataJson/treeData.json";

import { useAppContext } from "@/AppContext";
import {message,Input,Select,Modal,notification,Tooltip} from "antd";
import {LoadingOutlined,SaveOutlined,VerticalAlignTopOutlined,SwapOutlined,FullscreenOutlined,FullscreenExitOutlined,ExpandOutlined,ExpandAltOutlined,UnorderedListOutlined,EditFilled,ApartmentOutlined,ScheduleOutlined,ExperimentOutlined,AppstoreOutlined,PlusCircleOutlined,CloseOutlined,PlayCircleOutlined,EyeOutlined,EditOutlined,ExportOutlined,ImportOutlined,DeleteOutlined,GroupOutlined} from "@ant-design/icons";

import TreeFrame from "./treeFrame";
import ParamsEdit from "./ParamsEdit";
import Drawer from "@/Components/Drawer";
import Result from "@/Pages/Project/Flow/TaskManagement/TaskDate/ResultPageFrame";
import { jobs, simulation, deleteJob, getJob, updateJob,subjobs,getSubjobs,getSubjob,getSubJobs } from "@/services/common";
import { designValue, createDesignValue, deleteDesignValue, getDesignValue } from '@/services/design';
import { typeMap3 } from "@/constants/dataMap";
import { buildNodeDataByInput } from "./func/buildNodeDataByInput";
import { buildTaskInput } from "./func/buildInput";
import { buildSelectedElementData } from "./func/buildSelectedElementData";
import { buildRunNodes } from "./func/buildRunNodes";
import ParameterEditor from "./Diagram/ParameterEditor";
import { validateInput } from "./Diagram/validateInput";
import { openErrorNotification } from "./Diagram/ErrorsNotice";
import DesignValue from "./DesignValue/DesignValue";
import FixedCalModal from "@/Pages/Project/Flow/FixedData/Diagram/FixedCalModal";

import Dialog from "rc-dialog";
import Draggable from "react-draggable";
import "rc-dialog/assets/index.css";
import { clone } from "3dmol/build/types/WebGL";

interface ComponentProps {};

const Component = (props:ComponentProps) =>
{
  // const {allowUpDiagrams} = props;
  const [diagrams, setDiagrams] = useState<any>(null);
  const [overview, setOverview] = useState<boolean>(false);
  const [dataSource, setDataSource] = useState<any>(null);
  const { state, actions } = useAppContext();
  const [messageApi, contextHolder] = message.useMessage();
  const [overviewVisible, setOverviewVisible] = useState(true);
  const [readonly] = useState<boolean>(true); //仅有只读模式
  const [fullScreenViable, setFullScreenViable] = useState(false);
  const [screenSize, setScreenSize] = useState<number>(100);
  const diagramRef = useRef(null);
  const [treeVariable, setTreeVariable] = useState(true);
  const [treeWidth, setTreeWidth] = useState(300);//初始宽度300px
  const [isDragging, setIsDragging] = useState(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  //新变量
  const projectId = 138;  //项目ID
  const flowId = 532; //流程ID
  const token = userInfo.access_token;  //调用接口的token
  const allNodeNames = flowData.nodeDataArray.filter(item=>!item.isGroup&&item.elementName&&item.nodeName.trim()!=="").map(obj => obj["nodeName"]);
  const allLinkNames = flowData.linkDataArray.map(obj => obj["linkName"]);
  const dataSourceRef = useRef(dataSource); //等同于dataSource
  const [treeData,setTreeData] = useState(basicTreeData);  //树的数据
  const [tasks,setTasks] = useState([]);  //计算任务列表
  const [designs,setDesigns] = useState([]);  //设计值列表
  const [flowChartType,setFlowChartType] = useState("basic");  //basic:流程图,task:任务,design:设计值
  const [selectTaskData,setSelectTaskData] = useState(null);  //当前选中的任务数据，仅当flowChartType为task时生效
  const [selectDesignData,setSelectDesignData] = useState(null);  //当前选中的设计值数据，仅当flowChartType为design时生效
  const [creatTaskModalVariable, setCreatTaskModalVariable] = useState(false); //控制创建任务弹窗的开关
  const [creatDesignModalVariable, setCreatDesignModalVariable] = useState(false); //控制创建设计值弹窗的开关
  const [creatTaskName, setCreatTaskName] = useState(null); //创建时的任务名称
  const [creatDesignName, setCreatDesignName] = useState(null); //创建时的设计值名称
  const [creatTaskLoading, setCreatTaskLoading] = useState(false); //创建任务的loading开关
  const [creatDesignLoading, setCreatDesignLoading] = useState(false); //创建任务的loading开关
  const [paramsDrawerVariable,setParamsDrawerVariable] = useState(false);  //控制参数查看弹窗显隐
  const [selectedElementData,setSelectedElementData] = useState(null);  //选中参数数据，用于显示参数弹窗的数据
  const queryAllSubJobsIsRunningVariable = useRef(false);  //当前所选任务下是否查询全部的计算任务，false则不查询，true则查询，该变量避免重复查询
  const [changeLinkFlowValue,setChangeLinkFlowValue] = useState(null);  //调用Diagram.index文件的changeLinkFlow函数
  const [handleSelectVariable,setHandleSelectVariable] = useState({num:0,node:null});  //调用树组件中选中树节点函数的变量，其中num每次运行时+1，以触发函数，node为需要选中的节点，其格式与树选中时入参一致
  const [changeAllNodeIconGreenVariable,setChangeAllNodeIconGreenVariable] = useState({num:0});  //调用流程图组件中修改全部已计算元件变绿函数的变量，其中num每次运行时+1，以触发函数
  const [clearAllNodeIconHighVariable,setClearAllNodeIconHighVariable] = useState({num:0});  //调用流程图组件中清除全部元件高亮函数的变量，其中num每次运行时+1，以触发函数
  const [clearAllLinkHighVariable,setClearAllLinkHighVariable] = useState({num:0});  ////调用流程图组件中清除全部流股高亮函数的变量，其中num每次运行时+1，以触发函数
  const [clearAllGroupHighVariable,setClearAllGroupHighVariable] = useState({num:0});  ////调用流程图组件中清除全部分组高亮函数的变量，其中num每次运行时+1，以触发函数
  const [centerElement, setCenterElement] = useState({name:null,type:null}); //居中的元件/流股/分组，其中name为名称，type为上述三种类型之一
  const [upTaskOrDesignNameVariable,setUpTaskOrDesignNameVariable] = useState(false);  //控制修改任务或者设计值的名称,如果为true则开启编辑名称的模式，此时隐藏编辑按钮，文本改为输入框，显示保存按钮
  const [newTaskOrDesignName,setNewTaskOrDesignName] = useState(null);  //要修改任务或者设计值的新名称
  const [importDataVariable,setImportDataVariable] = useState(false);  //控制导入数据弹窗的显隐
  const [importDataType,setImportDataType] = useState({type:null,key:null});  //需要导入的数据的类型，type的值分别为all,node,link，对应全部、元件、流股,若type为all,则key为null,否则对应的是要导入的元件/流股的key
  const [importData, setImportData] = useState({type:null,id:null,name:null}); //被导入的流程图数据/任务/设计值，其中type为被导入的类型,为上述三种类型之一,id为选中的任务/设计值的id,name为选中的任务/设计值的name
  const [importDataLoading,setImportDataLoading] = useState(false); //导入流程图的loading开关
  const [checkDesignVariable,setCheckDesignVariable] = useState(false);  //控制查看设计值抽屉的显隐
  const [checkDesignData,setCheckDesignData] = useState(null);  //查看设计值的参数
  const [groupRunVariable,setGroupRunVariable] = useState(false);  //控制组合计算任务弹窗的开关
  const [multipleNodes,setMultipleNodes] = useState([]);  //Ctrl+点击在流程图中选中的元件

  const [isDirty,setIsDirty] = useState(false);  //判断该流程图参数是否进行了修改，若修改了后续需要提示需要保存
  const [isRunDone,setIsRunDone] = useState({variable:false,taskId:null});  //判断当前任务是否计算完成,其中variable为true代表计算完成，taskId为计算完成的任务ID
  const [subName,setSubName] = useState(null);  //当前选中计算结果名称，查看计算结果抽屉用
  const [deletingTaskId,setDeletingTaskId] = useState(null);  //正在删除的任务ID,记录该ID是为了后续和查询计算是否完成时避免因任务已删除导致接口报错的冲突
  const [runNodes,setRunNodes] = useState(null);  //已计算完的元件数据，用于树节点添加完成icon

  //其他变量
  const [notificationApi, notificationContextHolder] = notification.useNotification();
  const NOTICE_KEY = "error-notice";
  const closeErrorNoticeRef = useRef<(() => void) | null>(null);
  const errorNoticeContextRef = useRef<{
      close: () => void;
      validInfo: any;
      jsonData: any;
      notificationKey: string;
    } | null>(null);
  const [curResultInfo,setCurResultInfo]=useState<{id:null|number,type:null|'job'|'subJob'}>({
    id:null,
    type:null
  })
  const [resultDrawOpen, setResultDrawOpen] = useState(false);  //显示或隐藏结果抽屉

  useEffect(() => 
  {
    //展示固定流程图
    changeFlowChartType("basic");
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setFullScreenViable(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  useEffect(() => 
  {
    if (!diagrams) return;

    const onModelChange = (evt: go.ChangedEvent) => 
    {

    };

    // 监听模型变化
    diagrams.addModelChangedListener(onModelChange);

    // 清理监听器
    return () => 
    {
      diagrams.removeModelChangedListener(onModelChange);
    };
  }, [diagrams]);

  useEffect(() => 
  {
    dataSourceRef.current = dataSource;
  }, [dataSource]);

  //计算任务完成时触发
  useEffect(() => 
  {
    if(isRunDone.variable===true && isRunDone.taskId)
    {
      isRunDoneFunc();
    }
  }, [isRunDone]);

  //拖拽修改侧边栏尺寸
  const handleMouseDown = (e: React.MouseEvent) => 
  {
    e.preventDefault();
    setIsDragging(true);
    startXRef.current = e.clientX;
    startWidthRef.current = treeWidth;
  };

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging) return;
      const newWidth = startWidthRef.current + (e.clientX - startXRef.current);
      // 限制最小/最大宽度，防止拖出边界（可根据需要调整）
      if (newWidth >= 200 && newWidth <= 800) {
        setTreeWidth(newWidth);
      }
    };
    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const exportDiagram = () => {
    let flowName = state.curFlow["name"];

    let jsonData_json = JSON.parse(diagrams.model.toJson());
    // jsonData_json["modelData"] = {"position": "0 0"};
    let jsonData = JSON.stringify(jsonData_json);
    const blob = new Blob([jsonData], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = flowName; // 下载的文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const fullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullScreenViable(true);
    } else {
      document.exitFullscreen();
      setFullScreenViable(false);
    }
  };

  const adaptDiagram = () => {
    if (diagrams && diagrams.zoomToFit) {
      diagrams.zoomToFit();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "s") {
        e.preventDefault();

        //执行保存函数
        saveData();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  //元件居中并更改画面尺寸
  useEffect(() =>
  {
    if (centerElement.name && centerElement.type && diagrams) 
    {
      //画面跳转
      const model = diagrams.model;
      let targetPart = null;
      let targetKey = null;
      if (centerElement.type === "element_item") 
      {
        const node = model.nodeDataArray.find(
          (n: any) => n.nodeName === centerElement.name && !n.isGroup,
        );
        if (node) 
        {
          targetKey = node.key;
          targetPart = diagrams.findNodeForKey(targetKey);
        }
      } 
      else if (centerElement.type === "stream_item") 
      {
        const link = model.linkDataArray.find((l: any) => l.linkName === centerElement.name);
        if (link) 
        {
          targetKey = link.key;
          targetPart = diagrams.findLinkForKey(targetKey);
        }
      }
      else if (centerElement.type === "group") 
      {
        const group = model.nodeDataArray.find((l: any) => l.groupName === centerElement.name);
        if (group)
        {
          targetKey = group.key;
          targetPart = diagrams.findNodeForKey(targetKey);
        }
      }

      if (targetPart) 
      {
        // 居中显示
        //需要添加延时，否则分组时无法正常居中
        setTimeout(() => 
        {
          diagrams.centerRect(targetPart.actualBounds);
        }, 100);

        // 选中图元
        diagrams.select(targetPart);

        //更改画面尺寸
        if(centerElement.type!=="group")
        {
          setScreenSize(100);
          if (diagrams) {
            diagrams.scale = 100 / 100;
          }
        }
      }
      else 
      {
        if(centerElement.name!=="无工艺段")
        {
          messageApi.open({
            type: "error",
            content: "类型有误，查询失败",
          });
        }
      }
      setCenterElement({name:null,type:null});
    }
  }, [centerElement]);

  //更改选中流程图类型（切换流程图数据、计算任务、设计值）
  const changeFlowChartType = async (newFlowChartType:string,taskId?:number,designId?:number,newTasks?,newDesigns?) =>
  {
    if(newFlowChartType==="basic")
    {
      queryAllSubJobsIsRunningVariable.current = false;
      setIsRunDone({variable:false,taskId:null});
      setDeletingTaskId(null);
      setChangeLinkFlowValue({flowEnabled:false,nodeNames:[],linkNames:[]});
      setFlowChartType(newFlowChartType);
      setSelectTaskData(null);
      setSelectDesignData(null);
      setDataSource({data:flowData,cover:""});
      setUpTaskOrDesignNameVariable(false);
      setIsDirty(false);
      setRunNodes(null);
      
      //关闭当前参数弹窗
      setParamsDrawerVariable(false);
      setSelectedElementData(null);

      //渲染元件计算完的icon
      setChangeAllNodeIconGreenVariable({num:changeAllNodeIconGreenVariable.num+1});

      //修改树组合计算结果
      let newTreeData = structuredClone(treeData);
      newTreeData.subJobs = [];
      setTreeData(newTreeData);
    }
    else if(newFlowChartType==="task")
    {
      let input = await queryJob(taskId);
      if(input)
      {
        let taskDataJson = await buildTaskDataJson(input);
        let newRunNodes = await buildRunNodes(taskDataJson.nodeDataArray);

        queryAllSubJobsIsRunningVariable.current = false;
        setIsRunDone({variable:false,taskId:taskId});
        setDeletingTaskId(null);
        setChangeLinkFlowValue({flowEnabled:false,nodeNames:[],linkNames:[]});
        setFlowChartType(newFlowChartType);
        setSelectTaskData((newTasks??tasks).find(item=>item.id===taskId)??null);
        setSelectDesignData(null);
        setDataSource({data:taskDataJson,cover:""});
        setUpTaskOrDesignNameVariable(false);
        setIsDirty(false);
        setRunNodes(newRunNodes);

        //关闭当前参数弹窗
        setParamsDrawerVariable(false);
        setSelectedElementData(null);

        //渲染元件计算完的icon
        setChangeAllNodeIconGreenVariable({num:changeAllNodeIconGreenVariable.num+1});

        //查询组合计算结果
        let treeSubJobs =  await querySubJob(taskId);

        //修改树组合计算结果
        let newTreeData = structuredClone(treeData);
        newTreeData.subJobs = treeSubJobs;
        setTreeData(newTreeData);

        //查询流股动画
        queryAllSubJobsIsRunning(taskId);
      }
    }
    else if(newFlowChartType==="design")
    {
      let input = await queryDesignValue(designId);
      if(input)
      {
        let designDataJson = await buildTaskDataJson(input);

        queryAllSubJobsIsRunningVariable.current = false;
        setIsRunDone({variable:false,taskId:null});
        setDeletingTaskId(null);
        setChangeLinkFlowValue({flowEnabled:false,nodeNames:[],linkNames:[]});
        setFlowChartType(newFlowChartType);
        setSelectTaskData(null);
        setSelectDesignData((newDesigns??designs).find(item=>item.id===designId)??null);
        setDataSource({data:designDataJson,cover:""});
        setUpTaskOrDesignNameVariable(false);
        setIsDirty(false);
        setRunNodes(null);

        //关闭当前参数弹窗
        setParamsDrawerVariable(false);
        setSelectedElementData(null);

        //渲染元件计算完的icon
        setChangeAllNodeIconGreenVariable({num:changeAllNodeIconGreenVariable.num+1});

        //修改树组合计算结果
        let newTreeData = structuredClone(treeData);
        newTreeData.subJobs = [];
        setTreeData(newTreeData);
      }
    }
  };

  //查询计算任务
  const queryTask = async () =>
  {
    let res = await jobs({page:1,perPage:1000,flow_id:flowId },token);
    if (res.status === 200) 
    {
      let newTasks = res.data.data;
      setTasks(newTasks);
      return newTasks;
    } 
    else 
    {
      setTasks([]);
      messageApi.open
      ({
        type: "error",
        content: `计算任务查询失败：${res.status}`,
      });
      return [];
    }
  };

  //查询设计值
  const queryDesign = async () =>
  {
    let res = await designValue({flow_id:flowId},token);
    if (res.status === 200) 
    {
      let newDesigns = res.data;
      setDesigns(newDesigns);
      return newDesigns;
    } 
    else 
    {
      setDesigns([]);
      messageApi.open
      ({
        type: "error",
        content: `设计值查询失败：${res.status}`,
      });
      return [];
    }
  };

  //查询计算任务的job
  const queryJob = async (taskId) => 
  {
    const res = await getJob(taskId,token);
    if (res.status === 200) 
    {
      let inputStr = res.data.input;
      if (inputStr) 
      {
        let input = JSON.parse(inputStr);
        return input;
      } 
      else 
      {
        return null;
      }
    } 
    else 
    {
      message.error(`Job查询失败：${res.status}`);
      return null;
    }
  };

  //查询组合计算结果
  const querySubJob = async (taskId) => 
  {
    const res = await getSubJobs({ job_id: taskId }, token);
    if (res.status === 200) 
    {
      let subJobs = res.data.filter((item) => item.type === "multi");
      return subJobs;
    } 
    else 
    {
      message.error(`getSubJobs查询失败：${res.status}`);
      return [];
    }
  };

  //查询设计值的value
  const queryDesignValue = async (designId) => 
  {
    const res = await getDesignValue(designId,token);
    if (res.status === 200) 
    {
      let input = res.data.values.mix_input;
      return input;
    } 
    else 
    {
      message.error(`Job查询失败：${res.status}`);
      return null;
    }
  };

  //创建计算任务
  const creatTask = async () =>
  {
    //校验名称合法性
    if(!(await verifyTaskName(creatTaskName)))
    {
        messageApi.open
      ({
        type: "error",
        content:`计算任务 ${creatTaskName} 名称非法`,
      });
      return null;
    }

    let input = buildTaskInput(dataSource.data,allNodeNames,"False",creatTaskName,"creat",false);
    let res = await simulation(input,token);
    // let res = {status:200,data:{id:1}};
    if (res.status === 200) 
    {
      messageApi.open
      ({
        type: "success",
        content:`计算任务 ${creatTaskName} 创建成功`,
      });
      return res.data.id;
    } 
    else 
    {
      messageApi.open
      ({
        type: "error",
        content: `计算任务创建失败：${res.status}`,
      });
      return null;
    }
  };

  //创建设计值
  const creatDesign = async () =>
  {
    //校验名称合法性
    //设计值名称暂时无用，故无需校验名称

    let input = buildTaskInput(dataSource.data,allNodeNames,"False",creatDesignName,"creat",false);
    let desData = 
    {
      flow_id:flowId,
      type: "design",
      values:input
    };
    let res = await createDesignValue(desData,token);
    if (res.status === 200) 
    {
      messageApi.open
      ({
        type: "success",
        content:`设计值 ${creatDesignName} 创建成功`,
      });
      return res.data.id;
    } 
    else 
    {
      messageApi.open
      ({
        type: "error",
        content: `设计值创建失败：${res.status}`,
      });
      return null;
    }
  };

  //删除计算任务
  const deleteTask = async (id) =>
  {
    //删除标识
    setDeletingTaskId(id);

    let res = await deleteJob(id,token)
    if (res.status === 200) 
    {
      messageApi.open
      ({
        type: "success",
        content:"计算任务删除成功",
      });
      return true;
    }
    else
    {
      messageApi.open
      ({
        type: "error",
        content:`计算任务删除失败：${res.status}`,
      });
      return false;
    }
  };

  //删除计算设计值
  const deleteDesign = async (id) =>
  {
    let res = await deleteDesignValue(id,token)
    if (res.status === 200) 
    {
      messageApi.open
      ({
        type: "success",
        content:"设计值删除成功",
      });
      return true;
    }
    else
    {
      messageApi.open
      ({
        type: "error",
        content:`设计值删除失败：${res.status}`,
      });
      return false;
    }
  };

  //运行全部计算
  const runTask = async () =>
  {
    if(!selectTaskData)
    {
      messageApi.open({
        type: "error",
        content: "请选择计算任务",
      });

      return null;
    }

    let isNeedSave = await checkIsDirty();
    if(isNeedSave===true)
    {
      messageApi.open({
        type: "error",
        content: "请保存计算任务",
      });

      return null;
    }

    let input = buildTaskInput(dataSource.data,allNodeNames,"True",selectTaskData.name,"run",false);
    input["id"] = selectTaskData.id;

    // 校验数据合法性
    const validInfo = validateInput(input["mix_input"]);
    if (validInfo === "ok") 
    {
      let res = await simulation(input,token);
      if (res.status === 200) 
      {
        messageApi.open
        ({
          type: "success",
          content:`计算任务 ${selectTaskData.name} 开始计算`,
        });

        //元件居中且缩放100%

        //流股动画
        queryAllSubJobsIsRunning(selectTaskData.id);

        return res.data.id;
      } 
      else 
      {
        messageApi.open
        ({
          type: "error",
          content: `计算任务 ${selectTaskData.name} 开始计算失败`,
        });
        return null;
      }
    } 
    else 
    {
      //校验不通过
      let openErrorNotificationJsonData = structuredClone(dataSource.data);
      openErrorNotificationJsonData.job_id = selectTaskData.id;
      openErrorNotificationJsonData.job_name = selectTaskData.name;
      const closeFn = openErrorNotification(
        validInfo,
        notificationApi,
        NOTICE_KEY,
        openErrorNotificationJsonData,
        selectTreeItem
      );
      if (closeFn) 
      {
        closeErrorNoticeRef.current = closeFn;
        errorNoticeContextRef.current = {
          close: closeFn,
          validInfo: validInfo,
          jsonData: openErrorNotificationJsonData,
          notificationKey: NOTICE_KEY,
        };
      }

      return null;
    }
  };

  //运行单个计算
  const runPartTask = async (elementData) =>
  {
    if(!(elementData && selectTaskData))
    {
      messageApi.open({
        type: "error",
        content: "请选择计算任务",
      });

      return null;
    }

    let isNeedSave = await checkIsDirty();
    if(isNeedSave===true)
    {
      messageApi.open({
        type: "error",
        content: "请保存计算任务",
      });

      return null;
    }

    let input = buildTaskInput(dataSource.data,[elementData.elementName],"True",elementData.elementName,"creat",false);
    
    // 校验数据合法性
    const validInfo = validateInput(input["mix_input"]);
    if (validInfo === "ok") 
    {
      const subdata=
      {
        job_id:selectTaskData.id,
        job_type:"simulation",
        name:elementData.elementName,
        cal:'True',
        type:"single",//单个元件计算
        input:input["mix_input"],
        in_streams:input["mix_input"].streams.filter((s:any)=>s.type==='进料').map((i:any)=>i.name),
        out_streams:input["mix_input"].streams.filter((s:any)=>s.type==='出料').map((i:any)=>i.name),
        internal_streams:input["mix_input"].streams.filter((s:any)=>s.type==='内部').map((i:any)=>i.name),
      }

      let res = await subjobs(subdata,token);
      if (res.status === 200) 
      {
        messageApi.open
        ({
          type: "success",
          content:`计算任务 ${elementData.elementName} 开始计算`,
        });

        //元件居中且缩放100%

        //流股动画
        queryAllSubJobsIsRunning(selectTaskData.id);
        
        return res.data.id;
      } 
      else 
      {
        messageApi.open
        ({
          type: "error",
          content: `计算任务 ${elementData.elementName} 开始计算失败`,
        });
        return null;
      }
    } 
    else 
    {
      //校验不通过
      let openErrorNotificationJsonData = structuredClone(dataSource.data);
      openErrorNotificationJsonData.job_id = selectTaskData.id;
      openErrorNotificationJsonData.job_name = selectTaskData.name;
      const closeFn = openErrorNotification(
        validInfo,
        notificationApi,
        NOTICE_KEY,
        openErrorNotificationJsonData,
        selectTreeItem,
      );
      if (closeFn) 
      {
        closeErrorNoticeRef.current = closeFn;
        errorNoticeContextRef.current = {
          close: closeFn,
          validInfo: validInfo,
          jsonData: openErrorNotificationJsonData,
          notificationKey: NOTICE_KEY,
        };
      }

      return null;
    }
  };

  //运行组合计算
  const runGroupTask = async (elementDatas,groupTaskName) =>
  {
    if(!(elementDatas && selectTaskData))
    {
      messageApi.open({
        type: "error",
        content: "请选择计算任务",
      });

      return null;
    }

    let isNeedSave = await checkIsDirty();
    if(isNeedSave===true)
    {
      messageApi.open({
        type: "error",
        content: "请保存计算任务",
      });

      return null;
    }

    let input = buildTaskInput(dataSource.data,elementDatas.map(obj => obj['elementName']),"True",groupTaskName,"creat",false);
    
    // 校验数据合法性
    const validInfo = validateInput(input["mix_input"]);
    if (validInfo === "ok") 
    {
      const subdata=
      {
        job_id:selectTaskData.id,
        job_type:"simulation",
        name:groupTaskName,
        cal:'True',
        type:"multi",//组合元件计算
        input:input["mix_input"],
        in_streams:input["mix_input"].streams.filter((s:any)=>s.type==='进料').map((i:any)=>i.name),
        out_streams:input["mix_input"].streams.filter((s:any)=>s.type==='出料').map((i:any)=>i.name),
        internal_streams:input["mix_input"].streams.filter((s:any)=>s.type==='内部').map((i:any)=>i.name),
      }

      let res = await subjobs(subdata,token);
      if (res.status === 200) 
      {
        messageApi.open
        ({
          type: "success",
          content:`计算任务 ${groupTaskName} 开始计算`,
        });

        //元件居中且缩放100%

        //流股动画
        queryAllSubJobsIsRunning(selectTaskData.id);
        
        return res.data.id;
      } 
      else 
      {
        messageApi.open
        ({
          type: "error",
          content: `计算任务 ${groupTaskName} 开始计算失败`,
        });
        return null;
      }
    } 
    else 
    {
      //校验不通过
      let openErrorNotificationJsonData = structuredClone(dataSource.data);
      openErrorNotificationJsonData.job_id = selectTaskData.id;
      openErrorNotificationJsonData.job_name = selectTaskData.name;
      const closeFn = openErrorNotification(
        validInfo,
        notificationApi,
        NOTICE_KEY,
        openErrorNotificationJsonData,
        selectTreeItem
      );
      if (closeFn) 
      {
        closeErrorNoticeRef.current = closeFn;
        errorNoticeContextRef.current = {
          close: closeFn,
          validInfo: validInfo,
          jsonData: openErrorNotificationJsonData,
          notificationKey: NOTICE_KEY,
        };
      }

      return null;
    }
  };

  //查询当前任务下是否存在正在计算的任务
  const queryAllSubJobsIsRunning = async(taskId?) =>
  {
    if(queryAllSubJobsIsRunningVariable.current===false) //判断能否继续执行，该函数需要避免重复调用
    {
      queryAllSubJobsIsRunningVariable.current = true;
      
      setIsRunDone({variable:false,taskId:taskId});

      //每五秒查询一次计算结果
      let successQuerySubjobs = false;
      const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

      let num = 0;
      while( (!successQuerySubjobs) && (queryAllSubJobsIsRunningVariable.current===true) )
      {
        const startTime = Date.now();

        num++;

        let newChangeLinkFlowValue = 
        {
          flowEnabled:false,
          nodeNames:[],
          linkNames:[]
        };

        let res = await getSubjobs({job_id:taskId});
        if (res.status === 200) 
        {
          let subDatas = res.data.filter(item=>item.status!=="done" && item.status!=="error");
          if(subDatas.length>0)
          {
            //有正在计算的任务
            let newNodeNames = [];
            let newLinkNames = [];
            for(let i=0;i<subDatas.length;i++)
            {
              let newNodeName = subDatas[i].name;
              if(!newNodeNames.includes(newNodeName))
              {
                newNodeNames.push(newNodeName);
              }

              let newInLinksNames = subDatas[i].in_streams;
              let newOutLinksNames = subDatas[i].out_streams;
              let newInternalLinksNames = subDatas[i].internal_streams;
              for(let j=0;j<newInLinksNames.length;j++)
              {
                let newLinkName = newInLinksNames[j];
                if(!newLinkNames.includes(newLinkName))
                {
                  newLinkNames.push(newLinkName);
                }
              }
              for(let j=0;j<newOutLinksNames.length;j++)
              {
                let newLinkName = newOutLinksNames[j];
                if(!newLinkNames.includes(newLinkName))
                {
                  newLinkNames.push(newLinkName);
                }
              }
              if(newInternalLinksNames)
              {
                for(let j=0;j<newInternalLinksNames.length;j++)
                {
                  let newLinkName = newInternalLinksNames[j];
                  if(!newLinkNames.includes(newLinkName))
                  {
                    newLinkNames.push(newLinkName);
                  }
                }
              }
            }

            newChangeLinkFlowValue.flowEnabled = true;
            newChangeLinkFlowValue.nodeNames = newNodeNames;
            newChangeLinkFlowValue.linkNames = newLinkNames;
          }
          else
          {
            //没有正在计算的任务
            //无事发生
          }

          //查询父（全部）计算任务
          let res2 = await getJob(taskId,token);
          if (res2.status === 200) 
          {
            let curJobData = res2.data;
            if(curJobData)
            {
              if(curJobData.status==="done"||curJobData.status==="error"||curJobData.status==="unstart")
              {
                //没有正在计算的任务
                //无事发生
              }
              else
              {
                
                //有正在计算的任务
                let newNodeNames = allNodeNames;
                let newLinkNames = allLinkNames;

                newChangeLinkFlowValue.flowEnabled = true;
                newChangeLinkFlowValue.nodeNames = newNodeNames;
                newChangeLinkFlowValue.linkNames = newLinkNames;
              }
            }
          }
          else 
          {
            message.error(`查询计算任务失败：${res2.status}`);
            successQuerySubjobs = true;
          }
        
          if(newChangeLinkFlowValue.flowEnabled===false)
          {
            //没有任何正在计算的任务，可以停止循环查询
            successQuerySubjobs = true;
            queryAllSubJobsIsRunningVariable.current = false;
          }

          //更改流股动画
          setChangeLinkFlowValue(newChangeLinkFlowValue);
        }
        else 
        {
          message.error(`查询计算任务失败：${res.status}`);
          successQuerySubjobs = true;
        }
        const elapsed = Date.now() - startTime;
        await delay(Math.max(0, 5000 - elapsed));
      }

      //跳出循环后执行逻辑
      if(deletingTaskId!==taskId && num>1)
      {
        setIsRunDone({variable:true,taskId:taskId});
      }
    }
    return;
  };

  //保存当前流程图数据
  const saveData = async(input?) =>
  {
    if(flowChartType==="task")
    {
      let newTaskName = newTaskOrDesignName??selectTaskData.name;
      if(!input)
      {
        input = buildTaskInput(dataSource.data,allNodeNames,"False",newTaskName,"save");
      }
      const res = await updateJob(selectTaskData.id,input,token);
      if (res.status === 200) 
      {
        messageApi.open
        ({
          type: "success",
          content: `计算任务 ${newTaskName} 保存成功`,
        });

        setIsDirty(false);

        return true;
      } 
      else 
      {
        messageApi.open
        ({
          type: "error",
          content: `计算任务 ${newTaskName} 保存失败：${res.status}`,
        });
        return false;
      }
    }
    // else if(flowChartType==="design")
    // {

    // }
  };

  //查看任务计算结果（全部元件）
  const checkTaskResult = () =>
  {
    if(flowChartType==="task")
    {
      setCurResultInfo({
        id: selectTaskData.id,
        type: "job",
      });
      setResultDrawOpen(true);
      closeOtherDrawer("resultDraw")
    }
    else
    {
      messageApi.open({
        type: "error",
        content: "请选择计算任务",
      });
    }
  };

  //查看设计值
  const checkDesign = async() =>
  {
    if(selectDesignData)
    {
      let res = await getDesignValue(selectDesignData.id,token);
      if (res.status === 200) 
      {
        setCheckDesignData(res.data);
        setCheckDesignVariable(true);
        closeOtherDrawer("checkDesign");
      }
      else
      {
        messageApi.open
        ({
          type: "error",
          content:`设计值查询失败：${res.status}`,
        });
      }
    }
    else
    {
      messageApi.open
      ({
        type: "error",
        content: "请选择设计值",
      });
    }
  };

  //校验任务名称是否重复
  const verifyTaskName = async (taskName) =>
  {
    if(!taskName)
    {
      return false;
    }

    let res = await jobs({page:1,perPage:1000,flow_id:flowId },token);
    if (res.status === 200) 
    {
      let tasks = res.data.data;
      let taskNames = [];
      for(let i=0;i<tasks.length;i++)
      {
        taskNames.push(tasks[i].name);
      }
      if(taskNames.includes(taskName))
      {
        return false;
      }
      return true;
    } 
    else 
    {
      messageApi.open
      ({
        type: "error",
        content: `计算任务查询失败：${res.status}`,
      });
      return false;
    }
  };

  //构建新的流程图json(通过任务或设计值数据)
  const buildTaskDataJson = async (input) => 
  {
    let taskDataJson = structuredClone(flowData);
    for(let i=0;i<input.elements.length;i++)
    {
      let nodeName = input.elements[i].name;
      let nodeData = await buildNodeDataByInput(taskDataJson.nodeDataArray.find(item=>item.nodeName===nodeName),input,"node",globalData);
      
      taskDataJson.nodeDataArray[taskDataJson.nodeDataArray.findIndex(item =>item.nodeName===nodeName)] = nodeData;
    }
    for(let i=0;i<input.streams.length;i++)
    {
      let linkName = input.streams[i].name;
      let linkData = await buildNodeDataByInput(taskDataJson.linkDataArray.find(item=>item.linkName===linkName),input,"link",globalData);
      taskDataJson.linkDataArray[taskDataJson.linkDataArray.findIndex(item =>item.linkName===linkName)] = linkData;
    }
    
    return taskDataJson;
  };

  //选择树节点
  const selectTreeItem = (treeItem) =>
  {
    if(treeItem.elementType==="node")
    {
      let item = 
      {
          elementCategory:typeMap3[treeItem.elementNodeType],
          elementName:treeItem.elementName,
          groupKey:String(treeItem.elementGroupKey),
          groupName:treeItem.elementGroupKey!=="无" ? dataSource.data.nodeDataArray.find(item=>item.key===Number(treeItem.elementGroupKey) && item.isGroup).groupName:"无工艺段",
          itemKey:treeItem.elementID,
          path:["groups",String(treeItem.elementGroupKey),"elements",typeMap3[treeItem.elementNodeType],treeItem.elementName],
          type:"element_item"
      };
      setHandleSelectVariable({num:handleSelectVariable.num+1,node:item});
    }
    else if(treeItem.elementType==="link")
    {
      let item = 
      {
          streamName:treeItem.elementName,
          groupKey:String(treeItem.elementGroupKey),
          groupName:treeItem.elementGroupKey!=="无" ? dataSource.data.nodeDataArray.find(item=>item.key===Number(treeItem.elementGroupKey) && item.isGroup).groupName:"无工艺段",
          itemKey:treeItem.elementID,
          path:["groups",String(treeItem.elementGroupKey),"streams",treeItem.elementName],
          type:"stream_item"
      };
      setHandleSelectVariable({num:handleSelectVariable.num+1,node:item});
    }
    else if(treeItem.elementType==="group")
    {
      let item = 
      {
          groupName:treeItem.elementName,
          groupKey:String(treeItem.elementID),
          path:["groups",String(treeItem.elementID)],
          type:"group"
      };
      setHandleSelectVariable({num:handleSelectVariable.num+1,node:item});
    }
  };

  //导入数据至当前流程图
  const importDiagram = async() =>
  {
    if(!selectTaskData)
    {
      messageApi.open
      ({
        type: "error",
        content:"请选择计算任务",
      });
      return false;
    }

    //查询被导入的流程图数据/计算任务/设计值
    let dataJson = flowData;
    if(importData.type)
    {
      if(importData.type==="task")
      {
        if(importData.id)
        {
          let input = await queryJob(importData.id);
          dataJson = await buildTaskDataJson(input);
        }
        else 
        {
          messageApi.open
          ({
            type: "error",
            content:"请选择需要导入的计算任务",
          });
          return false;
        }
      }
      else if(importData.type==="design")
      {
        if(importData.id)
        {
          let input = await queryDesignValue(importData.id);
          dataJson = await buildTaskDataJson(input);
        }
        else 
        {
          messageApi.open
          ({
            type: "error",
            content:"请选择需要导入的设计值",
          });
          return false;
        }
      }
    }

    //根据不同的导入方式构建input
    let input = null;
    if(importDataType.type==="all")
    {
      input = buildTaskInput(dataJson,allNodeNames,"False",selectTaskData.name,"save");
      input = JSON.parse(input.input);
    }
    else if(importDataType.type==="node")
    {
      let oldNode = dataSource.data.nodeDataArray.find(item=>item.key===importDataType.key);
      let oldNodeIndex = dataSource.data.nodeDataArray.findIndex(item=>item.key===importDataType.key);
      let importNode = dataJson.nodeDataArray.find(item=>item.key===importDataType.key);

      if(oldNode && importNode)
      {
        //保留项，其余项被覆盖
        importNode.icon = oldNode.icon;
        importNode.isRun = oldNode.isRun;
      }
      else
      {
        messageApi.open
        ({
          type: "error",
          content:"数据有误",
        });
        return false;
      }
      dataSource.data.nodeDataArray[oldNodeIndex] = importNode;

      input = buildTaskInput(dataSource.data,allNodeNames,"False",selectTaskData.name,"save");
      input = JSON.parse(input.input);
    }
    else if(importDataType.type==="link")
    {
      let oldLink = dataSource.data.linkDataArray.find(item=>item.key===importDataType.key);
      let oldLinkIndex = dataSource.data.linkDataArray.findIndex(item=>item.key===importDataType.key);
      let importLink = dataJson.linkDataArray.find(item=>item.key===importDataType.key);

      if(oldLink && importLink)
      {
        //保留项，其余项被覆盖
        if(oldLink["flowEnabled"])
        {
          importLink["flowEnabled"] = oldLink["flowEnabled"];
        }
      }
      else
      {
        messageApi.open
        ({
          type: "error",
          content:"数据有误",
        });
        return false;
      }
      dataSource.data.linkDataArray[oldLinkIndex] = importLink;

      input = buildTaskInput(dataSource.data,allNodeNames,"False",selectTaskData.name,"save");
      input = JSON.parse(input.input);
    }

    //修改当前流程图
    if(input)
    {
      let taskDataJson = await buildTaskDataJson(input);
      setDataSource({data:taskDataJson,cover:""});
    }
    else
    {
      messageApi.open
      ({
        type: "error",
        content:"数据有误",
      });
      return false;
    }

    messageApi.open
    ({
      type: "success",
      content:"导入成功",
    });
    return true;
  };

  //修改当前流程图数据
  const upData = (data) =>
  {
    if(data.type==="node")
    {
      if(selectedElementData.elementID===data.key && selectedElementData.elementType===data.type)
      {
        let newSelectedElementData = structuredClone(selectedElementData);
        let newDataSource = structuredClone(dataSourceRef.current);

        newSelectedElementData.paramsData = data.paramsData;
        newSelectedElementData.basicData["描述"] = data.basicData["描述"];

        let newNode = newDataSource.data.nodeDataArray.find(item=>item.key===data.key);
        let newNodeIndex = newDataSource.data.nodeDataArray.findIndex(item=>item.key===data.key);
        newNode.ParamValues = data.paramsData;
        newNode.description = data.basicData["描述"].value;
        newDataSource.data.nodeDataArray[newNodeIndex] = newNode;

        setSelectedElementData(newSelectedElementData);
        setDataSource(newDataSource);
        setIsDirty(true);
      }
      else
      {
        messageApi.open
        ({
            type: "error",
            content: "数据有误，保存失败",
        });
      }
    }
    else if(data.type==="link")
    {
      if(selectedElementData.elementID===data.key && selectedElementData.elementType===data.type)
      {
        let newSelectedElementData = structuredClone(selectedElementData);
        let newDataSource = structuredClone(dataSourceRef.current);

        newSelectedElementData.paramsData = data.paramsData;
        newSelectedElementData.materialsData = data.materialsData;
        newSelectedElementData.basicData["描述"] = data.basicData["描述"];

        let newLink = newDataSource.data.linkDataArray.find(item=>item.key===data.key);
        let newLinkIndex = newDataSource.data.linkDataArray.findIndex(item=>item.key===data.key);
        newLink.ParamValues = data.paramsData;
        newLink.materials = data.materialsData;
        newLink.description = data.basicData["描述"].value;
        newDataSource.data.linkDataArray[newLinkIndex] = newLink;

        setSelectedElementData(newSelectedElementData);
        setDataSource(newDataSource);
        setIsDirty(true);
      }
      else
      {
        messageApi.open
        ({
            type: "error",
            content: "数据有误，保存失败",
        });
      }
    }
    else if(data.type==="group")
    {
      if(selectedElementData.elementID===data.key && selectedElementData.elementType===data.type)
      {
        let newSelectedElementData = structuredClone(selectedElementData);
        let newDataSource = structuredClone(dataSourceRef.current);

        newSelectedElementData.basicData["描述"] = data.basicData["描述"];

        let newNode = newDataSource.data.nodeDataArray.find(item=>item.key===data.key && item.isGroup);
        let newNodeIndex = newDataSource.data.nodeDataArray.findIndex(item=>item.key===data.key && item.isGroup);
        newNode.description = data.basicData["描述"].value;
        newDataSource.data.nodeDataArray[newNodeIndex] = newNode;

        setSelectedElementData(newSelectedElementData);
        setDataSource(newDataSource);
        setIsDirty(true);
      }
      else
      {
        messageApi.open
        ({
            type: "error",
            content: "数据有误，保存失败",
        });
      }
    }
  };

  //判断是否当前流程图需要保存
  const checkIsDirty = (): Promise<boolean> => 
  {
    return new Promise((resolve) => {
      if(flowChartType==="task" && selectTaskData)
      {
        if(isDirty===false)
        {
          resolve(false);
          return;
        }
        else
        {
          Modal.confirm
          ({
            content:`计算任务 ${selectTaskData.name} 未保存，是否需要保存`,
            onOk:async() => 
            {
              let res = await saveData();
              resolve(false);
            },
            onCancel: () => 
            {
              resolve(true);
            },
            okText: "保存",
            cancelText: "继续",
          });
        }
      }
      else
      {
        resolve(false);
      }
    });
  };

  //计算完成后执行的逻辑
  const isRunDoneFunc = async() =>
  {
    if(isRunDone.variable===true && isRunDone.taskId)
    {
      let taskId = isRunDone.taskId;
      let input = await queryJob(taskId);
      if(input)
      {
        let taskDataJson = await buildTaskDataJson(input);
        let newRunNodes = await buildRunNodes(taskDataJson.nodeDataArray);

        setDataSource({data:taskDataJson,cover:""});

        messageApi.open
        ({
          type: "success",
          content: "计算完成",
        });

        //渲染元件计算完的icon
        setChangeAllNodeIconGreenVariable({num:changeAllNodeIconGreenVariable.num+1});
        
        //渲染树节点计算完的icon
        setRunNodes(newRunNodes);
      }
    }
  };

  //抽屉打开时关闭其他抽屉
  const closeOtherDrawer = (drawerName:string) =>
  {
    if(drawerName==="checkDesign")
    {
      setParamsDrawerVariable(false);
      setGroupRunVariable(false);
      setResultDrawOpen(false);
    }
    else if(drawerName==="paramsDrawer")
    {
      setCheckDesignVariable(false);
      setGroupRunVariable(false);
      setResultDrawOpen(false);
    }
    else if(drawerName==="groupRun")
    {
      setCheckDesignVariable(false);
      setParamsDrawerVariable(false);
      setResultDrawOpen(false);
    }
    else if(drawerName==="resultDraw")
    {
      setCheckDesignVariable(false);
      setParamsDrawerVariable(false);
      setGroupRunVariable(false);
    }
  };

  console.log("=================================================================================================");

  // 返回组件的 JSX 结构
  return (
    <ReactFlowProvider>
          <PageTop
            mainContent={
              <Navbar />
            }
          />
           <>
      {contextHolder}
      {notificationContextHolder}
      <div style={{ display: "flex", flexDirection: "row", flex: 1, height: "100%" }}>
        {diagrams &&
        JSON.parse(diagrams.model.toJson()) ? (
          <div style={{ display: treeVariable ? "flex" : "none", width: treeWidth, height: "100%",position:"relative",flexShrink:0}}>
            <TreeFrame
              dataSource={dataSource.data} //当前流程图数据
              treeData={treeData} //树数据
              flowChartType={flowChartType} //basic:流程图,task:任务,design:设计值
              selectTaskData={selectTaskData}  //当前选中的任务数据，仅当flowChartType为task时生效
              selectDesignData={selectDesignData} //当前选中的设计值数据，仅当flowChartType为design时生效
              handleSelectVariable={handleSelectVariable} //调用树选中节点函数
              runNodes={runNodes} //已计算完的元件
              //查看计算结果相关变量
              setSubName={(newSubName)=>{setSubName(newSubName);}}
              setCurResultInfo={setCurResultInfo}
              setResultDrawOpen={setResultDrawOpen}

              openParamsModal={()=>{setParamsDrawerVariable(true);closeOtherDrawer("paramsDrawer");}} //打开参数弹窗
              //修改选中的元件
              setSelectedElementData={(node)=>
              {
                if((node.type==="group" && node.path.length===2)||(node.type==="element_item" && node.path.length===5))
                {
                  let elementData;
                  if(node.type==="element_item")
                  {
                    elementData = dataSourceRef.current.data.nodeDataArray.find(item=>item.key === node.itemKey);
                  }
                  else if(node.type==="group")
                  {
                    elementData = dataSourceRef.current.data.nodeDataArray.find(item=>item.key === Number(node.groupKey));
                  }

                  if(elementData)
                  {
                    setSelectedElementData(buildSelectedElementData(elementData));
                  }
                }
                else if(node.type==="stream_item" && node.path.length===4)
                {
                  let elementData = dataSourceRef.current.data.linkDataArray.find(item=>item.key === node.itemKey);
                  if(elementData)
                  {
                    setSelectedElementData(buildSelectedElementData(elementData));
                  }
                }
              }}
              //调用单个计算
              runPartTask={(node)=>
              {
                let elementData = dataSource.data.nodeDataArray.find(item=>item.key === node.itemKey);
                if(elementData)
                {
                  let newSelectedElementData = buildSelectedElementData(elementData)
                  runPartTask(newSelectedElementData);
                }
              }}
              //调用组合计算
              runGroupTask={(node)=>
              {
                let elementDatas = dataSource.data.nodeDataArray.filter(item=>item.group === Number(node.groupKey));
                if(elementDatas.length>0)
                {
                  let newSelectedElementDatas = [];
                  for(let i=0;i<elementDatas.length;i++)
                  {
                    let newSelectedElementData = buildSelectedElementData(elementDatas[i]);
                    newSelectedElementDatas.push(newSelectedElementData);
                  }
                  runGroupTask(newSelectedElementDatas,node.groupName);
                }
              }}
              //切换树节点时取消全部元件高亮
              setClearAllNodeIconHighVariable={()=>{setClearAllNodeIconHighVariable({num:clearAllNodeIconHighVariable.num+1});}}
              //切换树节点时取消全部流股高亮
              setClearAllLinkHighVariable={()=>{setClearAllLinkHighVariable({num:clearAllLinkHighVariable.num+1});}}
              //切换树节点时取消全部分组高亮
              setClearAllGroupHighVariable={()=>{setClearAllGroupHighVariable({num:clearAllGroupHighVariable.num+1});}}
              //居中元件/流股/分组
              setCenterElement={(newCenterElement)=>{setCenterElement(newCenterElement);}}
              //导入指定元件/流股
              setImportDataType={(newImportDataType)=>{setImportDataType(newImportDataType);setImportDataVariable(true);}}
            />
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
                width: 4,
                height: "100%",
                cursor: "col-resize",
                background: "transparent",
                zIndex: 10,
                userSelect: "none",
              }}
              onMouseDown={handleMouseDown}
            />
          </div>
        ) : null}

        <div
          className="diagram_component"
          style={{ padding: 0, margin: 0, flex: 1, overflowX: "hidden" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: 27,
              background: "#EEE",
              paddingLeft: 15,
              border: "solid #BBB",
              borderWidth: "1px 0 1px 0",
            }}
          >
            <button
              onClick={() => {
                setTreeVariable(!treeVariable);
              }}
              style={{
                width: 90,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 1px",
                background: treeVariable ? "#BBB" : "#EEE",
                color: treeVariable ? "#000" : "#5F5F5F",
                fontSize: 12,
              }}
            >
              <UnorderedListOutlined style={{ marginRight: 10 }} />
              导航菜单
            </button>

            <button
              onClick={async()=>{
                let isNeedSave = await checkIsDirty();
                changeFlowChartType("basic");
              }}
              style={{
                width: 90,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: flowChartType==="basic"?"#BBB":"#EEE",
                color: flowChartType==="basic"?"#000":"#5F5F5F",
                fontSize: 12,
              }}
            >
              <ApartmentOutlined style={{ marginRight: 10 }} />
              流程图数据
            </button>

            <div
              style={{
                display:"flex",
                flexDirection: "row",
                alignItems: "center",
                minWidth:310,
                height:"100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: flowChartType==="task"?"#BBB":"#EEE",
                color: flowChartType==="task"?"#000":"#5F5F5F",
                fontSize: 12,
              }}
            >
              <ScheduleOutlined style={{ marginLeft: 10, marginRight: 10 }} />
              计算任务
              <Select
                onChange={async(selectedValue,e) => 
                {
                  if(selectedValue)
                  {
                    let isNeedSave = await checkIsDirty();
                    changeFlowChartType("task",selectedValue,null,null,null);
                  }
                  else
                  {
                    let isNeedSave = await checkIsDirty();
                    changeFlowChartType("basic");
                  }
                }}
                value={selectTaskData?.name}
                style={{marginLeft:10,width:120,height:18.39,borderRadius:0,fontSize:12,paddingBottom:0,paddingTop:0,color: "#5F5F5F"}}
                onOpenChange={async() => {await queryTask();}}
                options={tasks.map(({name,id})=>({label:name,value:id}))}
                allowClear={true}
              />
              <button
                onClick={()=>{setCreatTaskModalVariable(true);}}
                title="创建计算任务"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="task"?"#BBB":"#EEE",
                  color: flowChartType==="task"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <PlusCircleOutlined/>
              </button>
              <button
                onClick={()=>{
                  Modal.confirm
                  ({
                    content:"是否确认运行任务",
                    onOk:() => 
                    {
                      runTask();
                    },
                    okText: "确认",
                    cancelText: "取消",
                  });
                }}
                title="运行任务"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="task"?"#BBB":"#EEE",
                  color: flowChartType==="task"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <PlayCircleOutlined/>
              </button>
              <button
                onClick={()=>{
                  if(!selectTaskData)
                  {
                    messageApi.open({
                      type: "error",
                      content: "请选择计算任务",
                    });
                    return;
                  }
                  setGroupRunVariable(true);
                  closeOtherDrawer("groupRun");
                }}
                title="单元组合运算"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="task"?"#BBB":"#EEE",
                  color: flowChartType==="task"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <GroupOutlined/>
              </button>
              <button
                onClick={()=>{
                  checkTaskResult();
                }}
                title="查看计算结果"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="task"?"#BBB":"#EEE",
                  color: flowChartType==="task"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <EyeOutlined/>
              </button>
              <button
                onClick={async()=>
                  {
                    if(selectTaskData)
                    {
                      Modal.confirm
                      ({
                        content:`是否确认删除计算任务 ${selectTaskData.name}`,
                        onOk:async() => 
                        {
                          //删除前取消查询流股动画
                          queryAllSubJobsIsRunningVariable.current = false;

                          let res = await deleteTask(selectTaskData.id);
                          if(res)
                          {
                            changeFlowChartType("basic");
                          }
                        },
                        okText: "确认",
                        cancelText: "取消",
                      });
                    }
                    else
                    {
                      messageApi.open
                      ({
                        type: "error",
                        content: "请选择计算任务",
                      });
                    }
                  }}
                title="删除计算任务"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="task"?"#BBB":"#EEE",
                  color: flowChartType==="task"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <DeleteOutlined/>
              </button>
            </div>

            <div
              style={{
                display:"flex",
                flexDirection: "row",
                alignItems: "center",
                minWidth:310,
                height:"100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: flowChartType==="design"?"#BBB":"#EEE",
                color: flowChartType==="design"?"#000":"#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExperimentOutlined style={{ marginLeft: 10, marginRight: 10 }} />
              设计值
              <Select
                onChange={async(selectedValue,e) => 
                {
                  if(selectedValue)
                  {
                    let isNeedSave = await checkIsDirty();
                    changeFlowChartType("design",null,selectedValue,null,null);
                  }
                  else
                  {
                    let isNeedSave = await checkIsDirty();
                    changeFlowChartType("basic");
                  }
                }}
                value={selectDesignData?.id}
                style={{marginLeft:10,width:120,height:18.39,borderRadius:0,fontSize:12,paddingBottom:0,paddingTop:0,color: "#5F5F5F"}}
                onOpenChange={async() => {await queryDesign();}}
                options={designs.map(({id})=>({label:id,value:id}))}
                allowClear={true}
              />
              <button
                onClick={()=>{setCreatDesignModalVariable(true);}}
                title="创建设计值"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="design"?"#BBB":"#EEE",
                  color: flowChartType==="design"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <PlusCircleOutlined/>
              </button>
              <button
                onClick={()=>{checkDesign();}}
                title="查看设计值"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="design"?"#BBB":"#EEE",
                  color: flowChartType==="design"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <EyeOutlined/>
              </button>
              <button
                onClick={async()=>
                  {
                    if(selectDesignData)
                    {
                      Modal.confirm
                      ({
                        content:`是否确认删除设计值 ${selectDesignData.id}`,
                        onOk:async() => 
                        {
                          let res = await deleteDesign(selectDesignData.id);
                          if(res)
                          {
                            changeFlowChartType("basic");
                          }
                        },
                        okText: "确认",
                        cancelText: "取消",
                      });
                    }
                    else
                    {
                      messageApi.open
                      ({
                        type: "error",
                        content: "请选择设计值",
                      });
                    }
                  }}
                title="删除设计值"
                style={{
                  width: 30,
                  height: "100%",
                  border: 0,
                  background: flowChartType==="design"?"#BBB":"#EEE",
                  color: flowChartType==="design"?"#000":"#5F5F5F",
                  fontSize: 12,
                }}
              >
                <DeleteOutlined/>
              </button>
            </div>
            
            {flowChartType==="task"?(
              <button
                onClick={() => {saveData();}}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <SaveOutlined style={{ marginRight: 10 }} />
                保存
              </button>
            ):null}

            <button
              onClick={() => {
                setOverviewVisible(!overviewVisible);
              }}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: overviewVisible ? "#BBB" : "#EEE",
                color: overviewVisible ? "#000" : "#5F5F5F",
                fontSize: 12,
              }}
            >
              <AppstoreOutlined style={{ marginRight: 10 }} />
              缩略图
            </button>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: 140,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExpandAltOutlined style={{ marginLeft: 10, marginRight: 10 }} />
              缩放
              <Input
                value={screenSize}
                suffix="%"
                onChange={(e) => {
                  const newValueStr = e.target.value;
                  if (newValueStr === "") {
                    messageApi.open({
                      type: "error",
                      content: "请输入数字",
                    });
                  } else {
                    const newValue = Number(newValueStr);
                    if (!isNaN(newValue)) {
                      setScreenSize(newValue);
                    } else {
                      messageApi.open({
                        type: "error",
                        content: "请输入数字",
                      });
                    }
                  }
                }}
                onPressEnter={(e) => {
                  const newValueStr = e.target["value"];
                  let newValue = null;
                  if (newValueStr !== "") {
                    newValue = Number(newValueStr);
                    if (Number.isNaN(newValue)) {
                      newValue = null;
                    }
                  }
                  if (newValue) {
                    setScreenSize(newValue);
                    //此处更改画面缩放尺寸
                    if (diagrams) {
                      diagrams.scale = newValue / 100;
                    }
                  } else {
                    messageApi.open({
                      type: "error",
                      content: "请输入数字",
                    });
                  }
                }}
                style={{
                  marginLeft: 10,
                  width: 65,
                  height: "80%",
                  borderRadius: 0,
                  fontSize: 12,
                  paddingBottom: 0,
                  paddingTop: 0,
                  color: "#5F5F5F",
                }}
              />
            </div>
            <button
              onClick={fullScreen}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              {fullScreenViable ? (
                <FullscreenOutlined style={{ marginRight: 10 }} />
              ) : (
                <FullscreenExitOutlined style={{ marginRight: 10 }} />
              )}
              {fullScreenViable ? "窗口" : "全屏"}
            </button>
            <button
              onClick={adaptDiagram}
              style={{
                width: 90,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExpandOutlined style={{ marginRight: 10 }} />
              适应屏幕
            </button>
            {flowChartType==="task"?(
              <button
                onClick={()=>{setImportDataType({type:"all",key:null});setImportDataVariable(true);}}
                style={{
                  width: 70,
                  height: "100%",
                  border: "solid #BBB",
                  borderWidth: "0 1px 0 0",
                  background: "#EEE",
                  color: "#5F5F5F",
                  fontSize: 12,
                }}
              >
                <ImportOutlined style={{ marginRight: 10 }} />
                导入
              </button>
            ):null}
            <button
              onClick={exportDiagram}
              style={{
                width: 70,
                height: "100%",
                border: "solid #BBB",
                borderWidth: "0 1px 0 0",
                background: "#EEE",
                color: "#5F5F5F",
                fontSize: 12,
              }}
            >
              <ExportOutlined style={{ marginRight: 10 }} />
              导出
            </button>

          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              width: "100%",
              height:40,
              paddingLeft:20,
              color:"#1b6ae7",
              fontSize:20,
              fontWeight:"bold"
            }}
          >
            {`${flowChartType==="basic"?"流程图数据":(flowChartType==="task"?"计算任务 ： ":(flowChartType==="design"?"设计值 ： ":"无类型"))}`}
            {(flowChartType==="task"||flowChartType==="design")&&(upTaskOrDesignNameVariable===true)?(
              <Input
                value = {newTaskOrDesignName}
                onChange={(e) => {setNewTaskOrDesignName(e.target.value);}}
                style={{
                  width:150,
                  height:30,
                  fontSize:18,
                  color: "#5F5F5F",
                  fontWeight:"bold"
                }}
              />
            ):(
              <div style={{minWidth:150}}>
                {`${flowChartType==="basic"?"":(flowChartType==="task"?`${selectTaskData?.name}`:(flowChartType==="design"?`${selectDesignData?.id}`:""))}`}
              </div>
            )}
            
            {(flowChartType==="task")&&(upTaskOrDesignNameVariable===false)?(
              <button
                title={`编辑${flowChartType==="task"?"计算任务":(flowChartType==="design"?"设计值":"")}名称`}
                onClick={() => 
                {
                  if(flowChartType==="task")
                  {
                    setNewTaskOrDesignName(selectTaskData.name);
                    setUpTaskOrDesignNameVariable(true);
                  }
                  else if(flowChartType==="design")
                  {
                    setNewTaskOrDesignName(selectDesignData.name);
                    setUpTaskOrDesignNameVariable(true);
                  }
                }}
                style={{
                  width: 40,
                  height: "100%",
                  border: "0px solid #BBB",
                  color:"#1b6ae7",
                  fontSize:16,
                  marginLeft:10,
                  backgroundColor:"transparent"
                }}
              >
                <EditOutlined/>
              </button>
            ):null}
            {(flowChartType==="task")&&(upTaskOrDesignNameVariable===true)?(
              <button
                title={`保存${flowChartType==="task"?"计算任务":(flowChartType==="design"?"设计值":"")}名称`}
                onClick={async() => 
                {
                  if(flowChartType==="task")
                  {
                    let res = await saveData();
                    if(res)
                    {
                      let newTasks =  await queryTask();
                      await changeFlowChartType("task",selectTaskData.id,null,newTasks,null);
                      setNewTaskOrDesignName(null);
                      setUpTaskOrDesignNameVariable(false);
                    }
                  }
                  else if(flowChartType==="design")
                  {
                    let res = await saveData();
                    if(res)
                    {
                      let newDesigns = await queryDesign();
                      await changeFlowChartType("design",null,selectDesignData.id,null,newDesigns);
                      setNewTaskOrDesignName(null);
                      setUpTaskOrDesignNameVariable(false);
                    }
                  }
                }}
                style={{
                  width: 40,
                  height: "100%",
                  border: "0px solid #BBB",
                  color:"#1b6ae7",
                  fontSize:16,
                  marginLeft:10,
                  backgroundColor:"transparent"
                }}
              >
                <SaveOutlined/>
              </button>
            ):null}
          </div>
            
          {/* 流程图 */}
          {dataSource ? (
            <>
              {/* 流程图主组件，接收以下 props：
                diagrams: 当前 mxGraph 实例
                settings: 包含 readonly 设置
                setDiagrams: 更新 diagrams 状态的函数（可能用于接收实例引用）
                dataSource: 初始流程图数据（图形结构）
            */}
              <div onContextMenu={(e) => e.preventDefault()}>
                <Diagram
                  diagrams={diagrams}
                  settings={{
                    readonly: readonly,
                  }}
                  setDiagrams={setDiagrams}
                  dataSource={dataSource.data}
                  overview={overviewVisible}
                  globalData={globalData}
                  onScaleChange={(scalePercent) => setScreenSize(scalePercent)}
                  diagramsRef={diagramRef}
                  selectedElementData={selectedElementData}
                  changeAllNodeIconGreenVariable={changeAllNodeIconGreenVariable}
                  clearAllNodeIconHighVariable={clearAllNodeIconHighVariable}
                  clearAllLinkHighVariable={clearAllLinkHighVariable}
                  clearAllGroupHighVariable={clearAllGroupHighVariable}
                  selectTreeItem={(treeItem)=>{selectTreeItem(treeItem)}}
                  openParamsModal={()=>{setParamsDrawerVariable(true);closeOtherDrawer("paramsDrawer");}}
                  changeLinkFlowValue={changeLinkFlowValue}
                  setMultipleNodes={setMultipleNodes}
                  flowChartType={flowChartType}
                  //查看计算结果相关变量
                  setSubName={(newSubName)=>{setSubName(newSubName);}}
                  setCurResultInfo={setCurResultInfo}
                  setResultDrawOpen={setResultDrawOpen}
                  //调用单个计算
                  runPartTask={(nodeKey)=>
                  {
                    let elementData = dataSource.data.nodeDataArray.find(item=>item.key === nodeKey);
                    if(elementData)
                    {
                      let newSelectedElementData = buildSelectedElementData(elementData)
                      runPartTask(newSelectedElementData);
                    }
                  }}
                  selectTaskData={selectTaskData}
                />
              </div>
            </>
          ) : (
            ""
          )}{" "}

        </div>
      </div>
      
      <Modal
        zIndex={2000}
        closable={false}
        centered={true}
        footer={null}
        width={400}
        open={creatTaskModalVariable}
        onCancel={() => {setCreatTaskModalVariable(false);setCreatTaskName(null);}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          任务名称
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          <Input
            value={creatTaskName}
            onChange={(e) => {setCreatTaskName(e.target.value);}}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setCreatTaskModalVariable(false);setCreatTaskName(null);}}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!creatTaskLoading?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14}}
            disabled={creatTaskLoading}
          >
            取消
          </button>
          <button
            onClick={async() => 
              {
                setCreatTaskLoading(true);
                let taskId = await creatTask();
                setCreatTaskLoading(false);

                if(taskId)
                {
                  let newTasks = await queryTask();
                  changeFlowChartType("task",taskId,null,newTasks,[]);

                  setCreatTaskModalVariable(false);
                  setCreatTaskName(null);
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!creatTaskLoading ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={creatTaskLoading}
          >
            <LoadingOutlined style={{ display: creatTaskLoading ? "flex" : "none", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>

      <Modal
        zIndex={2000}
        closable={false}
        centered={true}
        footer={null}
        width={400}
        open={creatDesignModalVariable}
        onCancel={() => {setCreatDesignModalVariable(false);setCreatDesignName(null);}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          设计值名称
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          <Input
            value={creatDesignName}
            onChange={(e) => {setCreatDesignName(e.target.value);}}
            style={{ flex: 1 }}
          />
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setCreatDesignModalVariable(false);setCreatDesignName(null);}}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!creatDesignLoading?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14}}
            disabled={creatDesignLoading}
          >
            取消
          </button>
          <button
            onClick={async() => 
              {
                setCreatDesignLoading(true);
                let designId = await creatDesign();
                setCreatDesignLoading(false);

                if(designId)
                {
                  let newDesigns = await queryDesign();
                  changeFlowChartType("design",null,designId,[],newDesigns);

                  setCreatDesignModalVariable(false);
                  setCreatDesignName(null);
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!creatDesignLoading ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={creatDesignLoading}
          >
            <LoadingOutlined style={{ display: creatDesignLoading ? "flex" : "none", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>

      <Modal
        zIndex={2000}
        closable={false}
        centered={true}
        footer={null}
        width={410}
        open={importDataVariable}
        onCancel={() => {setImportDataVariable(false);setImportDataType({type:null,key:null});setImportData({type:null,id:null,name:null})}}
      >
        <div style={{ marginBottom: 20, fontSize: 20, fontWeight: "bold", color: "#1b6ae7" }}>
          导入数据
        </div>
        <div style={{ marginBottom:20}}>
          <button
            onClick={()=>{setImportData({type:"basic",id:null,name:null});}}
            style={{
              width:120,
              height:30,
              border:(!importData.type||importData.type==="basic")?"0px":"1px solid #BBB",
              background: (!importData.type||importData.type==="basic")?"#1b6ae7":"#FFF",
              color: (!importData.type||importData.type==="basic")?"#FFF":"#BBB",
              fontSize:14,
            }}
          >
            <ApartmentOutlined style={{marginRight:10}}/>
            流程图数据
          </button>
          <button
            onClick={()=>{setImportData({type:"task",id:null,name:null});}}
            style={{
              width:120,
              height:30,
              borderTop: importData.type==="task"?0:"1px solid #BBB",
              borderBottom: importData.type==="task"?0:"1px solid #BBB",
              borderLeft:0,
              borderRight:0,
              background: importData.type==="task"?"#1b6ae7":"#FFF",
              color: importData.type==="task"?"#FFF":"#BBB",
              fontSize:14,
            }}
          >
            <ScheduleOutlined style={{marginRight:10}}/>
            计算任务
          </button>
          <button
            onClick={()=>{setImportData({type:"design",id:null,name:null});}}
            style={{
              width:120,
              height:30,
              border:importData.type==="design"?"0px":"1px solid #BBB",
              background: importData.type==="design"?"#1b6ae7":"#FFF",
              color: importData.type==="design"?"#FFF":"#BBB",
              fontSize:14,
            }}
          >
            <ExperimentOutlined style={{marginRight:10}}/>
            设计值
          </button>
        </div>
        <div style={{width:"100%",marginBottom:20}}>
          {importData?.type && (importData.type==="task"||importData.type==="design")?(
            <Select
              onChange={(val,e) => {
                if(val && e)
                {
                  setImportData({type:importData.type,id:val,name:e["label"]})
                }
                else
                {
                  setImportData({type:importData.type,id:null,name:null})
                }
              }}
              value={importData?.name}
              style={{width:"100%",height:30,fontSize:14,color: "#5F5F5F"}}
              onOpenChange={async() => {
                if(importData.type==="task")
                {
                  await queryTask();
                }
                else if(importData.type==="design")
                {
                  await queryDesign();
                }
              }}
              options={importData.type==="task" ? tasks.map(({name,id})=>({label:name,value:id})) : (importData.type==="design" ? designs.map(({id})=>({label:id,value:id})) : [])}
              allowClear={true}
            />
          ):(
            <div style={{width:"100%",height:30}}></div>
          )}
          
        </div>

        <div style={{ height: 32 }}>
          <button
            onClick={() => {setImportDataVariable(false);setImportDataType({type:null,key:null});setImportData({type:null,id:null,name:null})}}
            style={{position: "absolute",right: 25,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!importDataLoading?"#FF4D4F":"#ff9ea0",color: "#FFF",fontSize: 14}}
            disabled={importDataLoading}
          >
            取消
          </button>
          <button
            onClick={async() => 
              {
                setImportDataLoading(true);
                let res = await importDiagram();

                if(res)
                {
                  setImportDataLoading(false);
                  setImportDataVariable(false);
                  setImportDataType({type:null,key:null});
                  setImportData({type:null,id:null,name:null})
                }
              }}
            style={{display: "flex",alignItems: "center",justifyContent: "center",position: "absolute",right: 138,bottom: 10,width: 88,height: 32,border: 0,borderRadius: 5,background:!importDataLoading ? "#1b6ae7" : "#7fa7e7",color: "#FFF",fontSize: 14,}}
            disabled={importDataLoading}
          >
            <LoadingOutlined style={{ display: importDataLoading ? "flex" : "none", marginRight: 10 }} />
            <span>确认</span>
          </button>
        </div>
      </Modal>

      {/* 结果抽屉 */}
      <Drawer
        className="resultDrawer"
        open={resultDrawOpen}
        onOpenChange={setResultDrawOpen}
        title={null}
        width={treeVariable ? `calc(100vw - ${treeWidth}px)` : "100vw"}
        children={
          <div>
            <Result subJobid={selectTaskData?.id} item_name={subName} job_id={curResultInfo.id} type={curResultInfo.type} />
          </div>
        }
      />

      {/* 设计值抽屉 */}
      <Drawer
        open={checkDesignVariable}
        onOpenChange={setCheckDesignVariable}
        title={null}
        width={treeVariable ? `calc(100vw - ${treeWidth}px)` : "100vw"}
        children={
          // <DesignValue />
          checkDesignData && (<DesignValue
            values={checkDesignData?.values}
            item={checkDesignData}
          />)
        }
      />

      {/* 编辑参数抽屉 */}
      <Drawer
        open={paramsDrawerVariable}
        onOpenChange={setParamsDrawerVariable}
        title={null}
        width={treeVariable ? `calc(100vw - ${treeWidth}px)` : "100vw"}
        children={selectedElementData && (
          <ParamsEdit
            selectedElementData={selectedElementData} //选中元件/流股/分组数据
            dataSource={dataSource.data} //图数据
            globalData={globalData} //组分数据
            flowChartType={flowChartType} //选择图类型
            selectTaskData={selectTaskData} //当前选中的任务数据
            selectDesignData={selectDesignData} //当前选中的设计值数据
            closeParamsDrawer={()=>{setParamsDrawerVariable(false);}}  //关闭抽屉
            //调用选中树节点函数
            selectTreeItem={(node)=>{selectTreeItem(node)}}
            //修改参数
            upData={(data)=>{upData(data);}}
            //调用单个计算
            runPartTask={(nodeKey)=>
            {
              let elementData = dataSource.data.nodeDataArray.find(item=>item.key === nodeKey);
              if(elementData)
              {
                let newSelectedElementData = buildSelectedElementData(elementData)
                runPartTask(newSelectedElementData);
              }
            }}
          />)
        }
      />

      {/* 组合计算弹窗 */}
      <FixedCalModal
        visible={groupRunVariable}
        dataSource={dataSource?.data}
        onClose={() => setGroupRunVariable(false)}
        selectTaskData={selectTaskData}
        notificationApi={notificationApi}
        notificationKey={NOTICE_KEY}
        setQueryTask={queryTask}
        refreshSubJobs={async () => {
          if (selectTaskData) {
            const newSubJobs = await querySubJob(selectTaskData.id);
            setTreeData((prev) => ({ ...prev, subJobs: newSubJobs }));
          }
        }}
        multipleNodes={multipleNodes}
        selectTreeItem={(treeItem)=>{selectTreeItem(treeItem);}}
        //调用组合计算
        runGroupTask={async (nodeNames,runName)=>
        {
          let newSelectedElementDatas = [];
          for(let i=0;i<nodeNames.length;i++)
          {
            if(nodeNames[i])
            {
              let elementData = dataSource.data.nodeDataArray.find(item=>item.nodeName === nodeNames[i]);
              let newSelectedElementData = buildSelectedElementData(elementData);
              newSelectedElementDatas.push(newSelectedElementData);
            }
          }
          if(newSelectedElementDatas.length>0)
          {
            return runGroupTask(newSelectedElementDatas,runName);
          }
          return null;
        }}
      />

    </>
        </ReactFlowProvider>
   
  );
};

export default Component; // 导出组件，供其他模块使用
